import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-array-type',
  template: `
    <div>
      <div class="mb-3">
        <h5 class="mb-0" >{{ to.label }}</h5>
        <small *ngIf="to.description">{{ to.description }}</small>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="showError && formControl.errors">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>

      <div *ngFor="let field of field.fieldGroup;let i = index;" class="row align-items-center">
        <formly-field class="col" [field]="field"></formly-field>
        <div *ngIf="field.templateOptions.removable !== false" class="col-2 text-right">
          <button class="btn btn-sm btn-round btn-danger" type="button" (click)="remove(i)">
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>

      <div class="row align-items-center mt-2">
        <div class="col d-flex justify-content-end">
          <button class="btn btn-sm btn-round btn-primary" type="button" (click)="add()">
            <i class="material-icons">add</i>
          </button>
        </div>
      </div>
    </div>
  `,
})
export class ArrayTypeComponent extends FieldArrayType {}
